import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";
import redirectMomo from "../../../../common/momo_redirection";

export default function view() {
  const $this = this;
  const { $charge, $inputs } = this;
  $this.CAN_SWITCH_TO_CONFIRM = false;

  return (view = ViewFactory({
    NAME: 'MOMO_UGANDA_INIT_VIEW',
    inputs: ['phone'],
    next() {
      const phonenumber = getValueAtPath($inputs, '[phone].value');

      if (phonenumber) {
        $charge.init({
          data: { phonenumber },
          onRequireValidation() {
            $this.CAN_SWITCH_TO_CONFIRM = true;
          },

          onRequireRedirection() {
            const currentLocale = getValueAtPath($this, 'STATE.locale') || 'en';
            const isTestMode = getValueAtPath($this, 'STATE.isTestMode') || false;

            try {
              const { url } = this;

              redirectMomo(url, currentLocale, isTestMode)

            } catch(e) {}
          }
        });
      }
    }
  }).call(this));
}
